import React from 'react';

export default function LiveIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M6.16699 9.33325V10.9999" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.25 8.33325V11.6666" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10.333 9.33325V10.9999" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M2.5 6C2.5 5.17157 3.17157 4.5 4 4.5H12.5C13.3284 4.5 14 5.17157 14 6V7.69669C14 7.84028 14.1468 7.93708 14.2788 7.88052L16.803 6.7987C17.133 6.6573 17.5 6.89931 17.5 7.25827V13.691C17.5 14.0627 17.1088 14.3044 16.7764 14.1382L14.2894 12.8947C14.1565 12.8282 14 12.9249 14 13.0736V14C14 14.8284 13.3284 15.5 12.5 15.5H4C3.17157 15.5 2.5 14.8284 2.5 14V6Z"
        stroke="#262626"
      />
    </svg>
  );
}
